module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"privacyPolicy":"Privacy policy"}}')
  delete Component.options._Ctor
}
